import { Expose } from 'class-transformer';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class SnGroup extends SnModel {
  @Expose()
  public id: number;

  @Expose()
  public name: string;

  @ExposeRawData()
  public policies: any[];

  @Expose()
  public description: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
